import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import defaultClasses from '../../../components/BobTableContextMenu.module.css';

const FsmIntegrationContextMenu = ({
    integration,
    setIntegration,
    setDeleteAgentModalOpen,
    setRenameAgentModalOpen,
    setResetAuthKeyModalOpen,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDeleteAgent = () => {
        setDeleteAgentModalOpen(true);
        setIntegration(integration);
    };

    const handleRenameAgent = () => {
        setRenameAgentModalOpen(true);
        setIntegration(integration);
    };

    const handleRotateCredentials = () => {
        setResetAuthKeyModalOpen(true);
        setIntegration(integration);
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    onClick={() => handleRotateCredentials()}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-undo" />
                    Reset Authorization Key
                </MenuItem>
                <MenuItem
                    onClick={() => handleRenameAgent()}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-edit" />
                    Rename Agent
                </MenuItem>
                <MenuItem
                    onClick={() => handleDeleteAgent()}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-trash" />
                    Delete Agent
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

export default FsmIntegrationContextMenu;
